var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteHeaderProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 84C108.912 84 121 72.3594 121 58C121 43.6406 108.912 32 94 32C79.0883 32 67 43.6406 67 58C67 72.3594 79.0883 84 94 84Z",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 149H94H142V143.259C141.915 135.188 139.771 127.269 135.768 120.244C131.765 113.218 126.033 107.315 119.109 103.084C112.184 98.854 104.292 96.435 96.1709 96.0533C95.4468 96.0193 94.723 96.0015 94 96C93.277 96.0015 92.5532 96.0193 91.8291 96.0533C83.7076 96.435 75.816 98.854 68.8914 103.084C61.9669 107.315 56.2354 113.218 52.2322 120.244C48.2291 127.269 46.0849 135.188 46 143.259V149Z",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteHeaderProfile);
export default __webpack_public_path__ + "static/media/siteHeader-profile.70011fd50cd93a773765ebf49f504931.svg";
export { ForwardRef as ReactComponent };